import {
	emailOTPClient,
	inferAdditionalFields,
	magicLinkClient,
	organizationClient,
} from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";
import { auth } from "./auth";
import { ac, allRoles } from "./permissions";

export const authClient = createAuthClient({
	baseURL: process.env.NEXT_PUBLIC_BETTER_AUTH_URL,
	plugins: [
		organizationClient({
			ac,
			roles: allRoles,
		}),
		inferAdditionalFields<typeof auth>(),
		emailOTPClient(),
		magicLinkClient(),
	],
});

export const {
	signIn,
	signOut,
	useSession,
	useActiveOrganization,
	organization,
	useListOrganizations,
	useActiveMember,
} = authClient;
